(function () {
    'use strict';

    angular.module('swif.openbase')
    .config(route)
    .factory('swifOpenbaseConsumableService', swifOpenbaseConsumableService)
    .factory('swifOpenbaseConsumableCategoryService', swifOpenbaseConsumableCategoryService)
    .factory('swifOpenbasePrestationService', swifOpenbasePrestationService)

    .controller('ConsumablesController', ConsumablesController)
    .controller('ConsumableController', ConsumableController)
    .controller('ConsumableCategoriesController', ConsumableCategoriesController)
    .controller('ConsumableCategoryController', ConsumableCategoryController)
    .controller('PrestationsController', PrestationsController)
    .controller('PrestationController', PrestationController)

    .controller('ArticlesController', ArticlesController)
    .directive('thumbnailConsumable', thumbnailConsumable);

    function route ($routeProvider) {
        'ngInject';
        $routeProvider.when('/configuration/consumables/table_view', {
            templateUrl: 'partials/openbase/consumables_table_view.html',
            controller: 'ConsumablesController',
            reloadOnSearch: false,
            resolve: {
                data: ['swifRouteService', function (route) {
                    return route.check();
                }]
            }
        });
        $routeProvider.when('/configuration/consumable_categories/table_view', {
            templateUrl: 'partials/openbase/consumable_categories_table_view.html',
            controller: 'ConsumableCategoriesController',
            reloadOnSearch: false,
            resolve: {
                data: ['swifRouteService', function (route) {
                    return route.check();
                }]
            }
        });
        $routeProvider.when('/configuration/articles/table_view', {
            templateUrl: 'partials/openbase/articles_table_view.html',
            controller: 'ArticlesController',
            reloadOnSearch: false,
            resolve: {
                data: ['swifRouteService', function (route) {
                    return route.check();
                }]
            }
        });
    }

    /**
     * @ngdoc service
     * @name swif.openbase.swifOpenbaseConsumableService
     * @description consumable manager
     * @requires swif.framework.swifFrameworkService
     **/
    function swifOpenbaseConsumableService (swif) {
        'ngInject';
        var service = {};
        service.createCollection = function () {
            var filter = {};
            swif.data.sortOn(filter, 'name', 'ASC');
            return swif.collections.createOrUpdate('consumables', 'consumable', filter);
        };
        service.getCollection = function () {
            return swif.collections.getCollection('consumables');
        };
        service.callback = function (error, data) {
            service.getCollection().defaultActionCallback(error, data);
        };
        // create handles qty_available behavior (set value to context)
        service.create = function (model) {
            var context = {};

            if (model.is_stock) {
                model.default_warehouse_id = model.context_warehouse_id;
                context = {
                    price_unit: model.price,
                    qty_available: model.context_qty_available || 0.0,
                    warehouse_id: model.context_warehouse_id ? model.context_warehouse_id[0]: false
                };
            }

            return swif.data.create(model._type, model, context);
        };
        service.preValidate = function (data) {
            var ret = service.getCollection().preValidate(data);
            if (data.action.id === 'copy') {
                // _inherits field, must not be copied
                delete data.model.product_id;
            } else if (data.action.id === 'add') {
                ret = service.create(data.model);
            }
            return ret;
        };
        service.preModal = function (data) {
            swif.collections.getCollection('consumables').preModal(data);
            data.model._type = 'consumable';
        };
        return service;
    }


    function ConsumablesController ($scope, swifOpenbaseConsumableService) {
        'ngInject';
        swifOpenbaseConsumableService.createCollection()
        .then(function (collection) {
            $scope.consumables = collection;
        });
        $scope.preModal = swifOpenbaseConsumableService.preModal;
        $scope.preValidate = swifOpenbaseConsumableService.preValidate;
        $scope.callback = swifOpenbaseConsumableService.callback;
    }

    function ConsumableController ($scope, swif, AchatsService) {
        'ngInject';
        console.log('init ConsumableController');
        //back-end return false when default_code is empty.... and basic input display "false"...
        if (!$scope.model.default_code){
            $scope.model.default_code="";
        }
        $scope.filters = {
            consumable_category: {},
            warehouse: {}
        };
        AchatsService.filters.getWarehouseFilter($scope.filters.warehouse);
        $scope.modules = swif.module.modules;
        _.defaults($scope.model, {stock_threshold: 0, price: 0.0, context_qty_available: 0.0});
    }


    /**
     * @ngdoc service
     * @name swif.openbase.swifOpenbaseConsumableCategoryService
     * @description category manager
     * @requires swif.framework.swifFrameworkService
     **/
    function swifOpenbaseConsumableCategoryService (swif) {
        'ngInject';
        var service = {};
        service.createCollection = function () {
            var filter = {};
            swif.data.sortOn(filter, 'name', 'ASC');
            return swif.collections.createOrUpdate('consumable-categories', 'consumable_category', filter);
        };
        service.getCollection = function () {
            return swif.collections.getCollection('consumable-categories');
        };
        service.callback = function (error, data) {
            service.getCollection().defaultActionCallback(error, data);
        };
        service.preValidate = function (data) {
            return service.getCollection().preValidate(data);
        };
        service.preModal = function (data) {
            swif.collections.getCollection('consumable-categories').preModal(data);
        };
        return service;
    }


    function ConsumableCategoriesController ($scope, swifOpenbaseConsumableCategoryService) {
        'ngInject';
        swifOpenbaseConsumableCategoryService.createCollection()
        .then(function (collection) {
            $scope.consumableCategories = collection;
        });
        $scope.preValidate = swifOpenbaseConsumableCategoryService.preValidate;
        $scope.callback = swifOpenbaseConsumableCategoryService.callback;
    }


    function ConsumableCategoryController ($scope, swif) {
        'ngInject';
        console.log('init ConsumableCategoryController');
        $scope.filters = {
            department: {},
            parent: {}
        };
        $scope.$watch('model.id', function (newV) {
            // !scope.model.currentFilter filters model from collections objects
            // on list actions, scope.model refer to the collection, not the model
            if (newV && _.isNumber(newV) && !$scope.model.currentFilter) {
                swif.data.addFilter(
                    $scope.filters.parent,
                    'id', 'not in', [$scope.model.id]
                );
            }
        });
    }

    /**
     * @ngdoc service
     * @name swif.openbase.swifOpenbasePrestationService
     * @description prestation manager
     * @requires swif.framework.swifFrameworkService
     **/
    function swifOpenbasePrestationService (swif) {
        'ngInject';
        var service = {};
        service.createCollection = function () {
            var filter = {};
            swif.data.sortOn(filter, 'name', 'ASC');
            return swif.collections.createOrUpdate('prestations', 'prestation', filter);
        };
        service.getCollection = function () {
            return swif.collections.getCollection('prestations');
        };
        service.callback = function (error, data) {
            service.getCollection().defaultActionCallback(error, data);
        };
        service.preValidate = function (data) {
            if (data.action.id === 'copy') {
                // _inherits field, must not be copied
                delete data.model.product_id;
            }
            return service.getCollection().preValidate(data);
        };
        service.preModal = function (data) {
            service.getCollection().preModal(data);
        };
        return service;
    }

    function PrestationsController ($scope, swifOpenbasePrestationService) {
        'ngInject';
        console.log('init ArticlesController');
        swifOpenbasePrestationService.createCollection()
        .then(function (collection) {
            $scope.prestations = collection;
        });
        $scope.preModal = swifOpenbasePrestationService.preModal;
        $scope.preValidate = swifOpenbasePrestationService.preValidate;
        $scope.callback = swifOpenbasePrestationService.callback;
    }

    function PrestationController ($scope) {
        'ngInject';
        _.defaults($scope.model, {list_price: 0.0});
    }



    function ArticlesController ($scope, $q, swif) {
        'ngInject';
        $scope.modules = swif.module.modules;

        var user = swif.user.getAuthenticatedUserData();
        $scope.can = {
            display_furnitures: _.contains(user.access_rights, 'openbase_consumable_all'),
            display_prestations: _.contains(user.access_rights, 'openbase_prestation_all')
        };

        $scope.loading = {items: {}};
        $scope.refresh = function () {
            swif.message.loading($scope.loading.items);
            var deferred = [];
            _.forEach([
                'consumables',
                'prestations'
            ], function (name) {
                var collection = swif.collection.getCollection(name);
                if (collection) {
                    deferred.push(collection.getItems());
                }
            });
            $q.all(deferred).then(function () {
                swif.message.loading($scope.loading.items, 'ok');
            }, function () {
                swif.message.loading($scope.loading.items, 'ko');
            });
        };
    }

    function thumbnailConsumable (swif) {
        'ngInject';
        var ret = swif.panel.create_directive('consumable');
        ret.scope.light = '=?';
        ret.templateUrl = 'partials/openbase/thumbnail-consumable.html';
        return ret;
    }

})();
